import React from 'react';
import { IconProps } from '../../../DefaultIcon';

/*
same stuff vlu
 */
export function ConsultantsIcon({ className }: IconProps) {
  return (
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_1046)">
        <path
          d="M73.285 17.6969C72.3324 17.6969 71.5703 16.9348 71.5703 16.0034V5.27096C71.5703 4.2337 70.7236 3.40813 69.7075 3.40813H58.9962C58.0648 3.40813 57.3027 2.64606 57.3027 1.69348C57.3027 0.740898 58.0648 0 58.9962 0H69.7075C72.6076 0 74.9784 2.37087 74.9784 5.27096V15.9822C74.9784 16.9348 74.2164 17.6757 73.285 17.6757"
          fill="#00C4B3"
        />
        <path
          d="M1.71465 17.6969C0.783235 17.6969 0 16.9348 0 16.0034V5.27096C0 2.37087 2.37087 0 5.27096 0H15.9822C16.9348 0 17.6757 0.762066 17.6757 1.69348C17.6757 2.62489 16.9136 3.40813 15.9822 3.40813H5.27096C4.2337 3.40813 3.40813 4.25487 3.40813 5.27096V15.9822C3.40813 16.9348 2.64606 17.6757 1.71465 17.6757"
          fill="#00C4B3"
        />
        <path
          d="M15.9822 74.9999H5.27096C2.37087 74.9999 0 72.629 0 69.729V59.0177C0 58.0863 0.762066 57.3242 1.69348 57.3242C2.62489 57.3242 3.38696 58.0863 3.38696 59.0177V69.729C3.38696 70.7662 4.2337 71.5918 5.24979 71.5918H15.9611C16.8925 71.5918 17.6545 72.3539 17.6545 73.2853C17.6545 74.2167 16.8925 74.9787 15.9611 74.9787"
          fill="#00C4B3"
        />
        <path
          d="M69.7075 75.0002H58.9962C58.0648 75.0002 57.3027 74.2382 57.3027 73.3068C57.3027 72.3753 58.0648 71.6133 58.9962 71.6133H69.7075C70.7447 71.6133 71.5703 70.7665 71.5703 69.7504V59.0392C71.5703 58.1078 72.3324 57.3457 73.2638 57.3457C74.1952 57.3457 74.9573 58.1078 74.9573 59.0392V69.7504C74.9573 72.6717 72.5864 75.0214 69.6863 75.0214"
          fill="#00C4B3"
        />
        <path
          d="M38.2516 40.728C27.6039 40.728 18.7978 48.6874 17.4642 58.9753C17.2736 60.4147 18.4167 61.706 19.8774 61.706H56.6471C58.1077 61.706 59.2508 60.4147 59.0603 58.9753C57.7266 48.6874 48.9206 40.728 38.2728 40.728"
          fill="#00416B"
        />
        <path
          d="M54.3819 29.4243C54.3819 38.3363 47.1634 45.5547 38.2515 45.5547C29.3396 45.5547 22.1211 38.3363 22.1211 29.4243C22.1211 20.5124 29.3396 13.2939 38.2515 13.2939C47.1634 13.2939 54.3819 20.5124 54.3819 29.4243Z"
          fill="white"
        />
        <path
          d="M49.5555 29.4244C49.5555 35.6691 44.4963 40.7284 38.2516 40.7284C32.0069 40.7284 26.9688 35.6691 26.9688 29.4244C26.9688 23.1797 32.028 18.1416 38.2516 18.1416C44.4751 18.1416 49.5555 23.2009 49.5555 29.4244Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_1046">
          <rect width="75" height="75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
